module.exports = __webpack_public_path__ + "img/google16.94e46624.jpg";